export type SalesOrderEditControlGlyphKind =
  | "moduleReadOnly"
  | "approvedReadOnly"
  | "owner"
  | "heldByOther"
  | "securing"
  | "checking";

export function salesOrderEditControlGlyphKind(input: {
  isPendingOrder: boolean;
  isApproving: boolean;
  canEditOrder: boolean;
  heldByOther: boolean;
  isChecking: boolean;
  moduleWritesAllowed?: boolean;
}): SalesOrderEditControlGlyphKind {
  if (input.moduleWritesAllowed === false) {
    return "moduleReadOnly";
  }
  if (!input.isPendingOrder || input.isApproving) {
    return "approvedReadOnly";
  }
  if (input.canEditOrder) {
    return "owner";
  }
  if (input.heldByOther) {
    return "heldByOther";
  }
  return input.isChecking ? "securing" : "checking";
}
